export const optionType = [
    {label: 'تک انتخابی', value: 'single_choice'},
    {label: 'چند انتخابی', value: 'multiple_choice'},
    {label: 'تشریحی', value: 'text'},
];
